// import { CanvasProvider } from "components/ThreeItems/CanvasProvider";
import { ReactElement, useEffect, useRef, useState } from "react";
// import { useEditorContext } from "../EditorProvider";
// import { ThreeItems } from "components/ThreeItems/Exports";
import { Group, Matrix4, Vector3, Quaternion } from "three";

import { Properties } from "./properties";
// import { Actions } from "components/Actions/Actions";
import { useNavigate } from "react-router-dom";
import { PivotControls } from "@react-three/drei";
// import { SceneItemsType } from "components/ThreeItems/Scene";
import { Scene } from "components/ThreeItems/Scene";
import { CanvasProvider } from "components/ThreeItems/CanvasProvider";
import { AnimatePresence, motion } from "framer-motion"
import { Box, BuildingIcon, Layers, PlusIcon } from "lucide-react";
import { useLangContext } from "context/Lang";
import { Actions } from "components/Actions";
import { useMapEditorContext } from "../map-editor-provider";
import { Button } from "components/Button/Button";
import { Loader } from "components/Loader/Loader";
import { useDispatch } from "react-redux";
import { setToast } from "storeRedux/slices/toast";
import { ToastMessage } from "primereact/toast";
import { StringJSONPRS } from "utils/StringJsonPRS";
import Gazebo from "components/ThreeItems/gazebo";





type MapEditorEnvironmentProps = {
    canEdit?: boolean,
    inDialog?:boolean
}


export const MapEditorEnvironment = ({ canEdit,inDialog }: MapEditorEnvironmentProps): ReactElement => {

    const PivotRef = useRef<Group>(null);
    const isSelectedThreeItemRef = useRef<boolean>(false);
    const [loadingThreeItem,setLoadingThreeItem] = useState<boolean>(false);
    const { gW } = useLangContext();
    const dispatch  = useDispatch();
    const {
        handleDelete,
        addMesh,
        selectThreeItem,
        setSelectThreeItem,
        handleUpdate,
        handleLoadScene,
        handleSave,
        loadMeshes,
        loadMapItems,
        sceneItemsRef,
        getActiveThreeItems,
        setActiveThreeItems,
        threeItems,
        setThreeItems,
        activeThreeItems,
        getMeshesOfBuilding,
        getItemsOfMap,
        mapEditorId
    } = useMapEditorContext();




    const navigate = useNavigate();
    const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false);




    useEffect(()=>{
        canEdit&&getActiveThreeItems?.();
    },[canEdit])                               



    useEffect(() => {
        if (!selectThreeItem) {
            isSelectedThreeItemRef.current = false;
        }
    }, [selectThreeItem]);

    const handleDrag = (l: Matrix4, w: Matrix4) => {
        const position = new Vector3();
        const quaternion = new Quaternion();
        const scale = new Vector3();

        l?.decompose?.(position, quaternion, scale);




        if (selectThreeItem) {

            //// Position
            const P_X = document.getElementsByName("positionX");
            const P_Y = document.getElementsByName("positionY");
            const P_Z = document.getElementsByName("positionZ");

            const p_x = Number(((position.x * Number(PivotRef.current?.scale.x)) + Number(PivotRef.current?.position.x))?.toFixed(2));
            const p_y = Number(((position.y * Number(PivotRef.current?.scale.y)) + Number(PivotRef.current?.position.y))?.toFixed(2));
            const p_z = Number(((position.z * Number(PivotRef.current?.scale.z)) + Number(PivotRef.current?.position.z))?.toFixed(2));

            if (P_X?.length > 0)
                (P_X[0] as HTMLInputElement).value = p_x + ""

            if (P_Y?.length > 0)
                (P_Y[0] as HTMLInputElement).value = p_y + ""

            if (P_Z?.length > 0)
                (P_Z[0] as HTMLInputElement).value = p_z + ""


            selectThreeItem.position.set(p_x, p_y, p_z);


            //// Scale
            const S_X = document.getElementsByName("scaleX");
            const S_Y = document.getElementsByName("scaleY");
            const S_Z = document.getElementsByName("scaleZ");


            const s_x = Number(((scale.x) + (Number(PivotRef.current?.scale.x) || 0) - 1)?.toFixed(2));
            const s_y = Number(((scale.y) + (Number(PivotRef.current?.scale.y) || 0) - 1)?.toFixed(2));
            const s_z = Number(((scale.z) + (Number(PivotRef.current?.scale.z) || 0) - 1)?.toFixed(2));

            if (S_X?.length > 0)
                (S_X[0] as HTMLInputElement).value = s_x + ""

            if (S_Y?.length > 0)
                (S_Y[0] as HTMLInputElement).value = s_y + ""

            if (S_Z?.length > 0)
                (S_Z[0] as HTMLInputElement).value = s_z + ""


            selectThreeItem.scale.set(s_x, s_y, s_z);


            selectThreeItem.updateMatrix();

            selectThreeItem.userData.isUpdate = true;
        }
    }



    useEffect(()=>{
        getItemsOfMap?.({
            onError:()=>{

            },
            onGetData:(res:MapItem[])=>{
                setThreeItems?.(res)

                loadMapItems?.({
                    items:res,
                    group:sceneItemsRef?.current?.scene_group
                });
            }
        })
    },[]);





    


   



    const handlePlaceBuilding = (item: ActiveBuildingItem) => {

        
        let meshes = item.editorItem?.meshes;
        if(!meshes || meshes?.length ===0 ){
            setLoadingThreeItem(true)
            getMeshesOfBuilding?.({
                editorId:item.editorItem?.id,
                onError:(err)=>{
                    setLoadingThreeItem(false)
                    dispatch(setToast({ severity: "error", detail: gW(err) } as ToastMessage))
                    
                },
                onGetData:(res:any)=>{
                    meshes = res;
                    setLoadingThreeItem(false);
                    setActiveThreeItems?.(prev=>[...(prev||[])?.map(p=>{
                        if(p?.id!==item?.id){
                            return p
                        }else{
                            return {...p,editorItem:{...item?.editorItem,meshes}}
                        }
                    })])
                    
                    loadMeshes?.(meshes,(e)=>{
                        e.object.name=item?.editorItem?.building?.unitName||"";
                        e.object.userData.buildingId =item?.editorItem?.building?.id; 
                        if( sceneItemsRef?.current?.scene_group){
                            const group = sceneItemsRef.current.scene_group as Group;
                            group.children.push(e.object);
                            group.updateMatrix()
                            setSelectThreeItem?.(e.object);
                            setIsSidebarOpen(false)
                        }
                    }) 
                } 
            })
        }else {
            loadMeshes?.(meshes,(e)=>{
                e.object.name=item?.editorItem?.building?.unitName||"";
                e.object.userData.buildingId =item?.editorItem?.building?.id; 

                if( sceneItemsRef?.current?.scene_group){
                    const group = sceneItemsRef.current.scene_group as Group;
                    group.children.push(e.object);
                    group.updateMatrix()
                    setSelectThreeItem?.(e.object);
                    setIsSidebarOpen(false)
                }
            }) 
        }
    };


    


    return <div className="    " >
        
            
        

        {/* الشريط الجانبي الأيسر: قائمة المباني المتاحة للإسقاط */}
        {!selectThreeItem&&canEdit && (
            <div className="absolute top-20 start-4 z-10 flex flex-col gap-2 max-h-[85%] w-[320px]">
                <Button
                    variant="outline"
                    className="w-fit gap-2 shadow-md  backdrop-blur"
                    onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                >
                    <Layers size={18} />
                    {gW("available-items")}
                </Button>

                <AnimatePresence>
                    {isSidebarOpen && (
                        <motion.div
                            initial={{ x: -50, opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            exit={{ x: -50, opacity: 0 }}
                            className="bg-white/90 relative  backdrop-blur-md border border-primary-200 rounded-xl p-4 shadow-xl flex flex-col overflow-hidden h-[500px]"
                        >
                            
                            {loadingThreeItem&&<motion.div
                                initial={{  opacity: 0 }}
                                animate={{  opacity: 1 }}
                                exit={{  opacity: 0 }}
                                className=" absolute top-0 left-0 w-full h-full flex justify-center items-center bg-primary/10    "
                            >
                                <Loader/>
                            </motion.div>}
                            
                            <div className="border-b border-primary-100 pb-2 mb-3">
                                <h4 className="font-bold text-primary-800 text-sm flex items-center gap-2">
                                    <BuildingIcon size={16} />
                                    {gW("select-item-to-place")}
                                </h4>
                            </div>

                            <div className="flex-1 overflow-y-auto space-y-2 pr-1">
                                {activeThreeItems && activeThreeItems.length > 0 ? (
                                    activeThreeItems.map((item: ActiveBuildingItem) => (
                                        <div 
                                            key={item.id}
                                            title={item?.editorItem?.building?.title} 
                                            className="flex items-center justify-between p-3 bg-primary-50/50 hover:bg-primary-50 border border-primary-100/50 rounded-xl transition-all group"
                                        >
                                            <div className="flex flex-col overflow-hidden max-w-[70%]">
                                                <span  className="font-semibold text-xs text-primary-800 truncate">
                                                    {item?.editorItem?.building?.title || gW("unnamed-building")}
                                                </span>
                                                <span className="text-[10px] text-primary-400">
                                                    ID: {item.buildingId}
                                                </span>
                                            </div>
                                            <Button
                                                size="sm"
                                                className="gap-1 bg-primary-600 hover:bg-primary-700 text-white rounded-lg px-2 h-8"
                                                onClick={() => handlePlaceBuilding(item)}
                                            >
                                                <PlusIcon size={14} />
                                                {gW("place")}
                                            </Button>
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center py-10 text-primary-400 text-xs italic">
                                        {gW("no-active-items-found")}
                                    </div>
                                )}
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>
        )}

       

        <div className=" z-[1000]   absolute end-1 top-4 " >
            <Actions
                actions={!inDialog?["reload","back" ]:["reload"]}
                // onSave={() => handleSave?.(sceneItemsRef?.current?.scene?.children?.find(p => p?.name === "scene-group") || undefined)}
                onReload={() => { 
                    getActiveThreeItems?.()

                    getItemsOfMap?.({
                        onError:()=>{

                        },
                        onGetData:(res:MapItem[])=>{
                            
                            if(sceneItemsRef?.current?.scene_group){
                                sceneItemsRef.current.scene_group.children =[];
                            }
                            setThreeItems?.(res)
                            loadMapItems?.({
                                items:res,
                                group:sceneItemsRef?.current?.scene_group
                            });
                        }
                    }) 
                }}
                onBack={() => {
                    navigate(-1);
                }}
            />
        </div>

        {selectThreeItem && <motion.div
            initial={{ x: 100, opacity: 0.5 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
            style={{ scale: 0.80 }}
            className=" overflow-hidden    bg-primary-50/70 backdrop-blur rounded-xl  border border-primary-300   select-none h-full overflow-y-auto   w-[400px] flex flex-col gap-2 absolute top-0 end-0 z-10 "
        >



            <div className="flex p-2 h-[15%]  items-center gap-3 overflow-hidden">
                <div className="p-3 bg-primary/20 rounded-lg text-primary shadow-[0_0_10px_rgba(var(--primary-rgb),0.3)]">
                    <Box size={28} />
                </div>
                <div className="flex flex-col overflow-hidden">
                    <span className="text-[10px] uppercase tracking-widest text-primary font-bold">
                        {gW("properties")}
                    </span>
                    <h3 className="text-sm font-semibold truncate text-primary-700 ">
                        {selectThreeItem?.name || "Unnamed Mesh"}
                    </h3>
                </div>
            </div>

           

            <div className=" h-[60%] " >

                <Properties

                    animateType={{ animate: false }}
                    selectObject3DRef={{ current: selectThreeItem }}
                    PivotRef={PivotRef}

                    onCancel={() => {
                        if (!selectThreeItem.userData.id) {
                            sceneItemsRef?.current?.scene_group?.remove(selectThreeItem);
                        }
                        // selectMesh = selectMesh
                        setSelectThreeItem?.(null);
                        isSelectedThreeItemRef.current = false;
                    }}

                    onDelete={() => {
                        handleDelete?.({ mesh: selectThreeItem, effect: () => { isSelectedThreeItemRef.current = false } });
                    }}

                    onSave={() => {

                        if (selectThreeItem?.userData?.id) {
                            handleUpdate?.({ mesh: selectThreeItem, effect: () => { isSelectedThreeItemRef.current = false } })
                        } else {
                            handleSave?.({ mesh: selectThreeItem, effect: () => { isSelectedThreeItemRef.current = false } })
                        }
                    }}


                    // onCopy={(e) => {
                    //     handleSave?.({ mesh: e.clone(), copy: true });
                    // }}

                />
            </div>
        </motion.div>}


        <CanvasProvider 
            className=" z-0 absolute top-0 left-0  h-full   w-full " 
            activePlaneHelper={false} 
            showSky={false} 
            planeShowHelper={true} 
            planeScale={[100, 100, 0]}
            gW={gW}
            enableWebSocket={true}
            webSocketData={{
                mapId:mapEditorId
            }}

          
        >
            <Scene
                enableLOD={true}
                
                onSelect={(e) => {
                    if (canEdit && !isSelectedThreeItemRef.current) {
                        isSelectedThreeItemRef.current = true;
                        setSelectThreeItem?.(e?.parent)
                    }

                }}

                onLoad={(e) => handleLoadScene?.(e as SceneItemsProps)}
                isActiveSelect={ canEdit}
                
                showHelper={false}
            />
            {/* <Gazebo/> */}

            {/* <GetMeshes/>
                
            </ThreeItems.Scene> */}
            {selectThreeItem && <>
                <group position={selectThreeItem.position} scale={selectThreeItem.scale} ref={PivotRef}>
                    <PivotControls disableRotations={true} onDrag={handleDrag} scale={5} lineWidth={2} depthTest={false} >
                    </PivotControls>
                </group>
            </>}
            {/* <axesHelper ref={helperRef}  position={selectMesh.position} scale={[6,6,6]} /> */}
        </CanvasProvider>
    </div>
}




